import { WorkingPage } from "../../../layouts/NotData";

const DomainBuyAndSellCryptoTab = () => {
  return (
    <>
      <WorkingPage />
    </>
  );
};

export default DomainBuyAndSellCryptoTab;
